/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/AzureRMEndpointEditorWrapperComponent2" />
import * as React from "react";

import { IAzurRMComponentProps } from "DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/AzureRMAutoServicePrincipalEndpointEditorComponent";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";

import { IdentityType } from "DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Contracts/IdentityType";
import { AppRegistrationManualComponent } from "DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Manual/AppRegistrationManualComponent";
import { StoreManager } from "DistributedTask/Flux/StoreManager";
import { IIdenityTypeState, IdentityTypeStore } from "DistributedTaskUI/ServiceEndpoints/Editor/Stores/IdentityTypeStore";
import { ActionsCreatorInstanceIds } from "DistributedTaskUI/ServiceEndpoints/Editor/Constants";
import { NavigationActionsHub } from "DistributedTaskUI/ServiceEndpoints/Editor/Actions/NavigationActionsHub";
import { ActionsHubManager } from "DistributedTask/Flux/ActionsHubManager";
import { AppRegistrationAutomaticComponent } from "DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Automatic/AppRegistrationAutomaticComponent";
import { EndpointsEditorStore } from "DistributedTaskUI/ServiceEndpoints/Editor/Stores/EndpointsEditorStore";
import { AppRegistrationMIComponent } from "./ManagedIdentity/AppRegistrationMIComponent";
import * as Utils_String from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssPageService } from "VSS/Platform/Page";
import { ServiceEndpointType } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";
import * as EndpointConstants from "ServiceEndpoints/Client/Constants/ServiceEndpoint";
import { ActionCreatorManager } from "DistributedTask/Flux/ActionCreatorManager";
import { EndpointsEditorActionsCreator } from "DistributedTaskUI/ServiceEndpoints/Editor/Actions/EndpointsEditorActionsCreator";
import { AzureEndpointConstants, EndpointAuthorizationSchemes } from "ServiceEndpoints/Client/Constants/ServiceEndpoint";
import { CredentialTypeStore } from "DistributedTaskUI/ServiceEndpoints/Editor/Stores/CredentialTypeStore";

export class AzureRMEndpointEditorWrapperComponent2 extends VssComponent<IAzurRMComponentProps, IIdenityTypeState> {

    private readonly _identityStore: IdentityTypeStore;
    private readonly _endpointStore: EndpointsEditorStore;
    private readonly _navigationActions: NavigationActionsHub;
    private readonly _endpointsEditorActionsCreator: EndpointsEditorActionsCreator;

    constructor(props: IAzurRMComponentProps, context: IVssComponentContext) {
        super(props, context);

        this._navigationActions = ActionsHubManager.GetActionsHub<NavigationActionsHub>(NavigationActionsHub);
        this._navigationActions.setNavigateBack.addListener(this._onNavigateBack);
        this._navigationActions.setClosePanel.addListener(this._onClosePanel);

        this._endpointsEditorActionsCreator = ActionCreatorManager.GetActionCreator<EndpointsEditorActionsCreator>(EndpointsEditorActionsCreator, ActionsCreatorInstanceIds.EndpointsEditorActionsCreatorInstanceId);

        this._endpointStore = StoreManager.GetStore<EndpointsEditorStore>(EndpointsEditorStore, ActionsCreatorInstanceIds.EndpointsEditorStoreInstanceId);

        this._identityStore = StoreManager.GetStore<IdentityTypeStore>(IdentityTypeStore, ActionsCreatorInstanceIds.IdentityTypeStoreInstanceId, context.pageContext);
        this._identityStore.addChangedListener(this._onStoreChange);
        this.state = this._identityStore.getState();

    }

    public componentDidMount(): void {
        this._sanitizeAndInitializeEndpointType(this.props, this.context);
        const endpoint = this._endpointStore.getEndpoint();

        if (!endpoint.authorization.scheme) {
            this._endpointsEditorActionsCreator.initializeServiceEndpointAuthenticationScheme(EndpointAuthorizationSchemes.WorkloadIdentityFederation);
        }

        if (!endpoint.data.creationMode) {
            this._endpointsEditorActionsCreator.initializeServiceEndpointCreationMode(AzureEndpointConstants.SpnCreationModeAutomatic);
        }
    }

    public componentWillUnmount(): void {
        this._identityStore.removeChangedListener(this._onStoreChange);
        this._navigationActions.setNavigateBack.removeListener(this._onNavigateBack);
        this._navigationActions.setClosePanel.removeListener(this._onClosePanel);

        StoreManager.DeleteStore(IdentityTypeStore, IdentityTypeStore.getKey());
        StoreManager.DeleteStore(CredentialTypeStore, CredentialTypeStore.getKey());
    }

    public render(): React.ReactNode {
        const type = this.state.identityType;
        switch (type) {
            //TODO add other types here
            case IdentityType.AppRegistrationManual:
                this.props.hidePanelFooter(true);
                return <AppRegistrationManualComponent />;
            case IdentityType.AppRegistrationAutomatic:
                this.props.hidePanelFooter(true);
                return <AppRegistrationAutomaticComponent {... this.props}/>;
            case IdentityType.ManagedIdentityAgentAssigned:
                this.props.hidePanelFooter(false);
                return <AppRegistrationMIComponent {... this.props}/>;
            default:
                return <div>TBD {type}</div>;
        }
    }

    private _onStoreChange = (): void => {
        const state = this._identityStore.getState();
        this.setState(state);
    }

    private _onNavigateBack = (): void => {
        this.props.onBackButtonClick();
    }

    private _onClosePanel = (): void => {
        const endpoint = this._endpointStore.getEndpointClone();
        this.props.closePanel(endpoint);
    }
    
    private _sanitizeAndInitializeEndpointType(props: IAzurRMComponentProps, context: IVssComponentContext): void {
        let isHosted = AzureRMEndpointEditorWrapperComponent2._isHostedEnvironment(context.pageContext);
        this._serviceEndpointType = props.serviceEndpointType;
        if (!isHosted) {
            this._serviceEndpointType.inputDescriptors.forEach((inputDescriptor) => {
                if (Utils_String.equals(inputDescriptor.id, EndpointConstants.AzureEndpointConstants.ScopeLevel, true)) {
                    //removing the ML workspace scope for onPrem deployment
                    inputDescriptor.values.possibleValues = inputDescriptor.values.possibleValues.filter(possibleValue => possibleValue.value !== EndpointConstants.AzureEndpointConstants.WorkspaceString);
                }
            });
        }
    }

    private static _isHostedEnvironment(pageContext: IVssPageContext): boolean {
        if (pageContext) {
            const vssPageService = pageContext.getService<IVssPageService>("IVssPageService");
            if (vssPageService) {
                return vssPageService.getData().isHosted;
            }
        }

        return false;
    }

    private _serviceEndpointType: ServiceEndpointType;
}

VssComponent.register("endpoint-editor-component-azurerm-2", AzureRMEndpointEditorWrapperComponent2);